import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {getApplicationOfferDetail} from "./get_application_offer_detail";
import {getApplicationPropertyDetail, getApplicationPropertyDetailTypes} from "./get_application_property_detail";
import {getApplicationVendorDetail} from "./get_application_vendor_detail";

/**
 * Application related data
 */

type IApplicationRelatedDataPromise<T> = [Promise<IVendorDetailApplication | T>, Promise<IOfferDetailApplication | T>, Promise<IPropertyDetailApplication | T>];

const LEAD_DATA_PREFIX = `desktop/application/lead_data`;

export const getApplicationRelatedDataTypes = {
    ...createRequestActionTypes(LEAD_DATA_PREFIX),
    initialize: `${LEAD_DATA_PREFIX}_INITIALIZE`
};

export const getApplicationRelatedData = (storeHash: string, vendorId?: number, offerId?: number, propertyId?: number) => async (dispatch: Dispatch) => {
    dispatch({
        type: getApplicationRelatedDataTypes.start,
        id: storeHash
    });

    const promiseArray: IApplicationRelatedDataPromise<void> = [
        vendorId ? (dispatch(getApplicationVendorDetail(vendorId, storeHash)) as unknown as Promise<IVendorDetailApplication | void>) : Promise.resolve(),
        offerId ? (dispatch(getApplicationOfferDetail(offerId, storeHash)) as unknown as Promise<IOfferDetailApplication | void>) : Promise.resolve(),
        propertyId
            ? (dispatch(getApplicationPropertyDetail(propertyId, storeHash)) as unknown as Promise<IPropertyDetailApplication | void>)
            : Promise.resolve(undefined)
    ];

    return Promise.all(promiseArray as IApplicationRelatedDataPromise<undefined>)
        .then(() => {
            dispatch({
                type: getApplicationRelatedDataTypes.success,
                id: storeHash
            });
        })
        .catch(
            catch404(() => {
                dispatch({
                    type: getApplicationPropertyDetailTypes.error,
                    id: storeHash
                });
            })
        );
};

export const initializeApplicationRelatedData = (storeHash: string) => {
    return {type: getApplicationRelatedDataTypes.initialize, id: storeHash};
};
import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {getApplicationOfferDetail} from "./get_application_offer_detail";
import {getApplicationPropertyDetail, getApplicationPropertyDetailTypes} from "./get_application_property_detail";
import {getApplicationVendorDetail} from "./get_application_vendor_detail";

/**
 * Application related data
 */

type IApplicationRelatedDataPromise<T> = [Promise<IVendorDetailApplication | T>, Promise<IOfferDetailApplication | T>, Promise<IPropertyDetailApplication | T>];

const LEAD_DATA_PREFIX = `desktop/application/lead_data`;

export const getApplicationRelatedDataTypes = {
    ...createRequestActionTypes(LEAD_DATA_PREFIX),
    initialize: `${LEAD_DATA_PREFIX}_INITIALIZE`
};

export const getApplicationRelatedData = (storeHash: string, vendorId?: number, offerId?: number, propertyId?: number) => async (dispatch: Dispatch) => {
    dispatch({
        type: getApplicationRelatedDataTypes.start,
        id: storeHash
    });

    const promiseArray: IApplicationRelatedDataPromise<void> = [
        vendorId ? (dispatch(getApplicationVendorDetail(vendorId, storeHash)) as unknown as Promise<IVendorDetailApplication | void>) : Promise.resolve(),
        offerId ? (dispatch(getApplicationOfferDetail(offerId, storeHash)) as unknown as Promise<IOfferDetailApplication | void>) : Promise.resolve(),
        propertyId
            ? (dispatch(getApplicationPropertyDetail(propertyId, storeHash)) as unknown as Promise<IPropertyDetailApplication | void>)
            : Promise.resolve(undefined)
    ];

    return Promise.all(promiseArray as IApplicationRelatedDataPromise<undefined>)
        .then(() => {
            dispatch({
                type: getApplicationRelatedDataTypes.success,
                id: storeHash
            });
        })
        .catch(
            catch404(() => {
                dispatch({
                    type: getApplicationPropertyDetailTypes.error,
                    id: storeHash
                });
            })
        );
};

export const initializeApplicationRelatedData = (storeHash: string) => {
    return {type: getApplicationRelatedDataTypes.initialize, id: storeHash};
};
